/* RAZFRESCO.COM — minimal theme JS. No dependencies. */
(function () {
  'use strict';

  /* Hero slideshow — advances through the eras */
  function initSlideshow(root) {
    var slides = root.querySelectorAll('[data-rf-slide]');
    var counter = root.querySelector('[data-rf-counter]');
    if (slides.length < 2) return;
    var i = 0;

    /* The "interval" setting is in SECONDS (schema: min 1, max 10, unit "s").
       setInterval wants milliseconds — passing the raw value made the
       slideshow advance every 3ms. Convert, and tolerate a legacy ms value. */
    var raw = parseFloat(root.getAttribute('data-rf-interval'));
    if (!raw || raw <= 0) raw = 2.6;
    var delay = raw < 100 ? raw * 1000 : raw;
    if (delay < 800) delay = 800;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function paint() {
      for (var n = 0; n < slides.length; n++) {
        slides[n].classList.toggle('is-active', n === i);
      }
      if (counter) counter.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + slides.length).slice(-2);
    }
    paint();
    if (reduce) return;

    /* Clear any timer from a previous init on this element. The theme editor
       fires shopify:section:load repeatedly; without this the timers stack. */
    if (root.rfTimer) clearInterval(root.rfTimer);
    root.rfTimer = setInterval(function () {
      i = (i + 1) % slides.length;
      paint();
    }, delay);
  }

  /* Signup dropdown */
  function initSignup(root) {
    var trigger = root.querySelector('[data-rf-signup-trigger]');
    var panel = root.querySelector('[data-rf-signup-panel]');
    var close = root.querySelector('[data-rf-signup-close]');
    var caret = root.querySelector('[data-rf-caret]');
    if (!trigger || !panel) return;
    function set(open) {
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (caret) caret.textContent = open ? '▲' : '▼';
    }
    set(panel.hasAttribute('data-rf-open'));
    trigger.addEventListener('click', function () { set(panel.hidden); });
    if (close) close.addEventListener('click', function () { set(false); });
  }

  /* Bakery signup — posts to the streaming app, which creates the customer
     in BKRSCLB. razfresco.com and bkrsclb.com are separate Shopify stores;
     a native Shopify form here would create the customer in the WRONG one,
     where the streaming app could never authenticate them. */
  function initSignupForm(root) {
    var form = root.querySelector('[data-rf-signup-form]');
    if (!form || form.getAttribute('data-rf-bound')) return;
    form.setAttribute('data-rf-bound', '1'); // section:load can fire repeatedly

    var okEl = form.querySelector('[data-rf-signup-success]');
    var errEl = form.querySelector('[data-rf-signup-error]');
    var btn = form.querySelector('[data-rf-signup-submit]');
    var endpoint = form.getAttribute('data-rf-endpoint') || 'https://streaming.bkrsclb.com/api/signup';
    var label = btn ? btn.textContent : 'Sign up';

    function show(el, msg) {
      if (!el) return;
      el.textContent = msg;
      el.hidden = !msg;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var get = function (n) { var f = form.querySelector('[name="' + n + '"]'); return f ? f.value.trim() : ''; };
      var email = get('email');

      show(errEl, '');
      show(okEl, '');

      if (!email || email.indexOf('@') < 1) {
        show(errEl, 'Enter a valid email address.');
        return;
      }

      if (btn) { btn.disabled = true; btn.textContent = '…'; }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          username: get('username'),
          company: get('company'), // honeypot — real people leave this empty
          tag: form.getAttribute('data-rf-tag') || 'club-member-signed-up'
        })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (data && data.ok) {
            form.reset();
            show(okEl, form.getAttribute('data-rf-success') || "You're in.");
          } else {
            show(errEl, (data && data.error) || 'Something went wrong. Try again.');
          }
        })
        .catch(function () {
          show(errEl, "Couldn't reach the server. Try again in a moment.");
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    });
  }

  /* Variant picker — swaps the ?variant= id and price without a page reload */
  function initVariants(root) {
    var data = root.querySelector('[data-rf-variant-data]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-rf-variant-id]');
    var priceEl = root.querySelector('[data-rf-price]');
    var submit = root.querySelector('[data-rf-submit]');
    var buttons = root.querySelectorAll('[data-rf-swatch]');

    function select(id) {
      var v = null;
      for (var n = 0; n < variants.length; n++) { if (String(variants[n].id) === String(id)) v = variants[n]; }
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
      for (var b = 0; b < buttons.length; b++) {
        buttons[b].setAttribute('aria-checked', buttons[b].getAttribute('data-rf-swatch') === String(v.id) ? 'true' : 'false');
      }
      if (submit && !submit.hasAttribute('data-rf-locked')) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? submit.getAttribute('data-rf-label') : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener('click', function (e) {
        select(e.currentTarget.getAttribute('data-rf-swatch'));
      });
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var i, list;
    list = document.querySelectorAll('[data-rf-slideshow]');
    for (i = 0; i < list.length; i++) initSlideshow(list[i]);
    list = document.querySelectorAll('[data-rf-signup]');
    for (i = 0; i < list.length; i++) { initSignup(list[i]); initSignupForm(list[i]); }
    list = document.querySelectorAll('[data-rf-product]');
    for (i = 0; i < list.length; i++) initVariants(list[i]);
  });

  /* Shopify theme editor re-renders sections without a full reload */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    if (s.querySelector('[data-rf-slideshow]')) initSlideshow(s.querySelector('[data-rf-slideshow]'));
    if (s.querySelector('[data-rf-signup]')) {
      initSignup(s.querySelector('[data-rf-signup]'));
      initSignupForm(s.querySelector('[data-rf-signup]'));
    }
    if (s.querySelector('[data-rf-product]')) initVariants(s.querySelector('[data-rf-product]'));
  });
})();
